import React from "react";

const LeaveReports = () => {
    return <div>Leave Reports</div>;
};

export default LeaveReports;